import { memo } from 'react';
import PlayerTimelineButton from './PlayerTimelineButton';
import { useChapterSegmentNavigation } from '../hooks/useChapterSegmentNavigation';

const NextChapter = () => {
  const { onClickNext, isNextDisabled, isFullClip } = useChapterSegmentNavigation();

  return (
    <PlayerTimelineButton
      tooltipTitle={isFullClip ? 'Next Chapter' : 'Go to end'}
      buttonId="next-chapter-button"
      onClick={onClickNext}
      isDisabled={isNextDisabled}
      iconName="IconPlayerSkipForward"
    />
  );
};

export default memo(NextChapter);
